import { render, staticRenderFns } from "./CommentRecord.vue?vue&type=template&id=40e8daad&scoped=true"
import script from "./CommentRecord.vue?vue&type=script&lang=js"
export * from "./CommentRecord.vue?vue&type=script&lang=js"
import style0 from "./CommentRecord.vue?vue&type=style&index=0&id=40e8daad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e8daad",
  null
  
)

export default component.exports